import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SearchBoxConfig } from "@spartacus/storefront";


@Component({
  selector: 'app-product-search',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.scss'],
})
export class ProductSearchComponent implements OnInit {
  @Output() selectedProductEvent = new EventEmitter<any>();
  @Input() clearSearchValue = false;
  QUICKORDER_SEARCH_BOX_CONFIG: SearchBoxConfig = {
    minCharactersBeforeRequest: 3,
    displayProducts: true,
    displaySuggestions: false,
    displayProductImages: false,
  };

  constructor() { }

  ngOnInit(): void { }
  onProductSelected(product) {
    this.selectedProductEvent.emit({ name: product.baseProductInfo.name, code: product.baseProductInfo.variantInfo[product.index].code });
  }
}
